import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'geo-round-checkbox',
  templateUrl: 'round-checkbox.component.html',
  styleUrls: ['./round-checkbox.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RoundCheckboxComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class RoundCheckboxComponent implements ControlValueAccessor {
  @Input() indeterminate = false;

  value = false;

  writeValue(value: boolean) {
    this.value = value;
    this.propagateChange(value);
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
    return;
  }

  protected propagateChange = (_: any | null) => {
    return;
  }
}
